import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetInformationDb } from '../redux/sheetInformationDbSlice';
import useCurrentDb from './useCurrentDb';

const useSheetInformationDbs = () : [string[], SheetInformationDb[]] => {
  const [sheetId] = useCurrentDb();
  const sheetInformations = useSelector((state: RootState) => state.sheetInformationDb).sheetInformations;
  const ids = Object.keys(sheetInformations).filter(id => sheetInformations[id].sheetId === sheetId);
  ids.sort((a, b) => {
    return sheetInformations[a].order - sheetInformations[b].order;
  })
  const values = ids.map(id => sheetInformations[id]);

  return [ids, values];
}

export default useSheetInformationDbs;
